const HEADLINE_TYPES = {
    title: 'title',
    head1: 'head1',
    head2: 'head2',
    head3: 'head3',
    head4: 'head4',
    head5: 'head5',
    subHead1: 'sub-head1',
    subHead2: 'sub-head2'
}

export { HEADLINE_TYPES }
